import React, { useEffect } from 'react'
import { useTranslation } from "react-i18next";
import { useSelector } from 'react-redux';
import { selectLanguage } from '../redux/language/selector';
import DeeplinkContent from '../components/DeepLink/DeepLinkContent';

const Deeplink = () => {
    const {t} =useTranslation()
      const language = useSelector(selectLanguage);
  useEffect(() => {
    document.title = t("deeplink-page.title");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [language]);


  return (
    <>
     
        <DeeplinkContent/>
        
    </>
  )
}

export default Deeplink